import { Injectable } from '@angular/core';
import { ethers } from "ethers";
import { sleep } from "../utils";

export interface IFee
{
  amount: string;
  priorityAmount: string;
  time: number;
  coinAmount?:string;
}

export interface IOracleFee
{
  safe: IFee,
  propose: IFee,
  fast: IFee
}

@Injectable({
  providedIn: 'root'
})
export class UtilsService
{
  constructor()
  {}

  public gweiToWei(_gwei: string)
  {
    const gasBigNumber = ethers.parseUnits(_gwei.toString(), 'gwei');
    return ethers.formatUnits(gasBigNumber, 'wei').split('.')[0];
  }

  public gweiToEther(_gwei: string)
  {
    const gasBigNumber = ethers.parseUnits(_gwei.toString(), 'gwei');
    return ethers.formatEther(gasBigNumber);
  }

  public formatUints(_number, uint?: string)
  {
    return ethers.formatUnits(_number, uint);
  }

  public parseUints(_number: string, uint?: string)
  {
    return ethers.parseUnits(_number, uint);
  }

  private async getEstimationOfConfirmTime(_gas: string)
  {
    try
    {
      const wei = this.gweiToWei(_gas);

      // avoid etherscan server rate limit (5 requests per sec)
      await sleep(300);

    //   return await this.explorer.GetEstimatationOfConfirmTime(wei);
    }
    catch (e)
    {
      return 0;
    }
  }
}
